import { TimeAllocationType } from '../work-periods-client/work-periods-client.type';

type Page = {
  id?: string;
  name: string;
  description: string;
  layout: string;
  components?: Component[];
  type: string;
  organization: string;
  portfolio: string;
  module_type: string;
  page_template: string | null;
  data_entry_components?: DataEntryComponent[];
};

type PageWritePayload = Omit<Page, 'id'> & {
  page_template_inputs: Record<string, string>;
};

type LayoutData = {
  x: number;
  y: number;
  w: number;
  h: number;
};

type Component = {
  id?: string;
  page: string;
  name: string;
  description: string;
  type: string;
  sub_type?: string;
  show_title: boolean;
  component_data?: ComponentData[];
  layout_data?: LayoutData;
};

type ComponentData = {
  id?: string;
  measure: string;
  range_type: string;
  object_type: string;
  object_ids: string[];
  unit?: string;
  color_map: Record<string, string>;
  time_allocation_type?: TimeAllocationType;
};

type PageTemplateInput = {
  key: string;
  object_type: string;
  id?: string;
};

type PageTemplateComponent = Omit<Component, 'page'>;

type PageTemplateConfig = {
  inputs: PageTemplateInput[];
  components: PageTemplateComponent[];
  data_entry_components: DataEntryComponent[];
};
type PageTemplate = {
  id: string;
  name: string;
  description: string;
  layout: string;
  organization: string;
  portfolio: string;
  config: PageTemplateConfig;
};

type PageTemplateWritePayload = {
  name: string;
  description: string;
};

enum DataEntryDataType {
  TEXT = 'text',
  FLOAT = 'float',
  INTEGER = 'int',
  BOOLEAN = 'boolean',
  DATE = 'date',
  DATETIME = 'datetime',
}

type DataEntryColumnData = {
  name: string;
  data_type: DataEntryDataType;
};

type DataEntryStoredData = {
  [key: string]: string | number | boolean | null;
};

type DataEntryComponent = {
  id?: string;
  page: string;
  name: string;
  description: string;
  stored_data: DataEntryStoredData[];
  column_data?: DataEntryColumnData[];
  layout_data?: LayoutData;
};

export { DataEntryDataType };

export type {
  Component,
  ComponentData,
  DataEntryColumnData,
  DataEntryComponent,
  DataEntryStoredData,
  LayoutData,
  Page,
  PageTemplate,
  PageTemplateComponent,
  PageTemplateConfig,
  PageTemplateInput,
  PageTemplateWritePayload,
  PageWritePayload,
};
